import inno from "../assets/logos/company/innodata.png";
import sjp from "../assets/logos/company/usjp-logo.png";
import cpn from "../assets/logos/company/coursera-projectnetwork-purplesquare.png";
import cl from "../assets/logos/company/cousera-logo.jpg";
import fl from "../assets/logos/company/futurelearn-logo.jpg";
import edX from "../assets/logos/company/edX-logo.jpg";
import ttp from "../assets/logos/company/ttp-logo.jpg";
import csds from "../assets/logos/company/csds-logo.png";
import jesa19 from "../assets/logos/company/jesa-2019.jpg";
import jesa21 from "../assets/logos/company/jesa-2021.jpg";
import cssl from "../assets/logos/company/css-logo.jpg";
import leo from "../assets/logos/company/leo-logo.jpg";
import ieee from "../assets/logos/company/ieee.png";
import niche from "../assets/logos/company/nichelabs.jpg";
import logo99x from "../assets/logos/company/99x.jpg";
import nestle from "../assets/logos/company/Nestle_Logo.png";
import ashi from "../assets/logos/company/ashidesignLogo.png";
import ac from "../assets/logos/company/a&c.jpg";

import js from "../assets/logos/techs/js.png";
import html from "../assets/logos/techs/html.png";
import css from "../assets/logos/techs/css.png";
import sass from "../assets/logos/techs/sass.png";
import bootstrap from "../assets/logos/techs/bootstrap.png";
import dart from "../assets/logos/techs/dart.png";
import php from "../assets/logos/techs/php.png";
import python from "../assets/logos/techs/python.png";
import pascal from "../assets/logos/techs/pascal.jpg";
import java from "../assets/logos/techs/java.png";
import c from "../assets/logos/techs/c.png";
import react from "../assets/logos/techs/react.png";
import next from "../assets/logos/techs/next.svg";
import redux from "../assets/logos/techs/redux.svg";
import flutter from "../assets/logos/techs/flutter.png";
import vue from "../assets/logos/techs/vue.png";
import vite from "../assets/logos/techs/vite.png";
import reactbootstrap from "../assets/logos/techs/reactbootstrap.png";
import mui from "../assets/logos/techs/mui.png";
import antd from "../assets/logos/techs/antd.png";
import mt from "../assets/logos/techs/material-tailwind-logo.png";
import jquery from "../assets/logos/techs/jquery.png";
import laravel from "../assets/logos/techs/laravel.png";
import node from "../assets/logos/techs/nodejs.png";
import express from "../assets/logos/techs/express.png";
import graphql from "../assets/logos/techs/graphql.png";
import rest from "../assets/logos/techs/rest.png";
import apollo from "../assets/logos/techs/apollo.png";
import axios from "../assets/logos/techs/axios.png";
import mongodb from "../assets/logos/techs/mongodb.png";
import mysql from "../assets/logos/techs/mysql.png";
import dynamoDB from "../assets/logos/techs/dynamoDB.png";
import s3 from "../assets/logos/techs/s3.png";
import ec2 from "../assets/logos/techs/ec2.svg";
import cf from "../assets/logos/techs/cloudfront.png";
import acm from "../assets/logos/techs/acm.png";
import iam from "../assets/logos/techs/iam.png";
import r53 from "../assets/logos/techs/r53.png";
import ddb from "../assets/logos/techs/dynamoDB.png";
import lamda from "../assets/logos/techs/lamda.png";
import ses from "../assets/logos/techs/ses.png";
import api from "../assets/logos/techs/api.png";
import cw from "../assets/logos/techs/cloudwatch.png";
import aws from "../assets/logos/techs/aws.png";
import vercel from "../assets/logos/techs/vercel.png";
import cp from "../assets/logos/techs/cpanel.png";
import gh from "../assets/logos/techs/github.png";
import gl from "../assets/logos/techs/gitlab.png";
import bb from "../assets/logos/techs/bitbucket.png";
import asana from "../assets/logos/techs/asana.svg";
import jira from "../assets/logos/techs/jira.png";
import alb from "../assets/logos/techs/alb.png";
import cloudformation from "../assets/logos/techs/cloudformation.png";
import ecr from "../assets/logos/techs/ecr.png";
import ecs from "../assets/logos/techs/ecs.png";
import fargate from "../assets/logos/techs/fargate.png";
import waf from "../assets/logos/techs/waf.png";
import gitrunner from "../assets/logos/techs/gitrunner.png";
import docker from "../assets/logos/techs/docker.png";
import eslint from "../assets/logos/techs/eslint.png";
import prettier from "../assets/logos/techs/prettier.png";
import sonarqube from "../assets/logos/techs/sonarqube.png";
import genai from "../assets/logos/techs/genai.png";
import ts from "../assets/logos/techs/ts.png";

import figma from "../assets/logos/techs/figma.webp";
import xd from "../assets/logos/techs/xd.png";
import canva from "../assets/logos/techs/canva.png";
import ps from "../assets/logos/techs/photoshop.png";
import il from "../assets/logos/techs/illustrator.png";
import ae from "../assets/logos/techs/aftereffect.png";
import pr from "../assets/logos/techs/premirepro.png";
import filmora from "../assets/logos/techs/filmora.webp";
import blender from "../assets/logos/techs/blender.png";

import ev1 from "../assets/imgs/events/csdsGloryNight.jpeg";
import ev2 from "../assets/imgs/events/JESASemifinalist.jpg";
import ev3 from "../assets/imgs/events/csdsGloryNight2.jpg";
import ev4 from "../assets/imgs/events/AdeeshaMahalekamGraduate.jpg";
import ev5 from "../assets/imgs/events/NesternshipConfirmation.jpg";
import ev6 from "../assets/imgs/events/Nesternship.jpg";
import ev7 from "../assets/imgs/events/NesternCentralPerkVirtualHangout.jpg";
import ev8 from "../assets/imgs/events/NesternGlobalSportfest.jpg";
import ev9 from "../assets/imgs/events/VRealCertificate.jpg";
import ev10 from "../assets/imgs/events/99xVirtualVesak.jpg";
import ev11 from "../assets/imgs/events/99xBristolBrainBattle.jpg";
import ev12 from "../assets/imgs/events/csdsGloryNight3.jpeg";
import ev13 from "../assets/imgs/events/csdsGloryNight4.jpeg";
import ev14 from "../assets/imgs/events/csdsGloryNight5.jpeg";
import ev15 from "../assets/imgs/events/CSR4.jpeg";
import ev16 from "../assets/imgs/events/CSR1.jpeg";
import ev17 from "../assets/imgs/events/CSR2.jpeg";
import ev18 from "../assets/imgs/events/CSR3.jpeg";
import ev19 from "../assets/imgs/events/JESAOrganizingComettee.jpeg";
import ev20 from "../assets/imgs/events/SJPfunEvent.jpeg";
import ev21 from "../assets/imgs/events/SJPfunEvent2.jpeg";
import ev22 from "../assets/imgs/events/Aurora1.jpeg";
import ev23 from "../assets/imgs/events/Aurora2.jpeg";
import ev24 from "../assets/imgs/events/Aurora3.jpeg";
import ev25 from "../assets/imgs/events/PotraitDrawingGift.jpeg";
import ev26 from "../assets/imgs/events/SceintiaExhibition1.jpg";
import ev27 from "../assets/imgs/events/SceintiaExhibition2.jpeg";
import ev28 from "../assets/imgs/events/SceintiaExhibition3.jpeg";
import ev29 from "../assets/imgs/events/AstronomyNight.jpeg";
import ev30 from "../assets/imgs/other/Adeesha Mahalekam Graduation (1).jpeg";
import ev31 from "../assets/imgs/other/Adeesha Mahalekam Graduation (2).jpeg";

export const profExperiences = [
  {
    title: "Senior Software Engineer (Frontend Specialist)",
    where: "Innodata Lanka (Pvt) Ltd",
    startDate: "2025-01-01",
    endDate: "Present",
    logo: inno,
    des: "Innodata is a global data engineering company delivering the promise of AI to many of the world's most prestigious companies. In here I'm working with Intelligent Automated Publishing Platform.",
    items: [
      {
        title: "Intelligent Automated Publishing Platform Editor 2.0",
        des: "Editor 2.0 is next-generation XML-based editor developed from scratch using ProseMirror. I designed and implemented the overall editor architecture using React.js, TypeScript, Vite, and Node.js, establishing scalable development patterns, file structures, and naming conventions to ensure long-term maintainability. I also structured the editor’s UI layout with intuitive user flows aligned to modern UI/UX principles, while developing core data fetching and validation mechanisms to improve responsiveness and data integrity. In addition, I developed major reusable editor plugins to extend content authoring capabilities and worked extensively with XML, XSD, Schema, and JSON for structured data handling. I set up Git branching strategies, ESLint, Prettier, and automated test cases to meet SonarQube quality standards and CI/CD coverage requirements. I implemented automated deployment workflows using GitHub Runners and AWS, improved overall system performance, ensured full cross-browser compatibility, and integrated AI-powered proofreading plugins using generative AI. Alongside development, I conducted regular code reviews, contributing to higher code quality and mentoring junior developers.",
        techs: [
          {
            tech: "React JS",
            logo: react,
          },
          {
            tech: "Typesript",
            logo: ts,
          },
          {
            tech: "Material UI",
            logo: mui,
          },
          {
            tech: "Vite",
            logo: vite,
          },
          {
            tech: "NodeJS",
            logo: node,
          },
          {
            tech: "CSS",
            logo: css,
          },
          {
            tech: "ESLint",
            logo: eslint,
          },
          {
            tech: "Prettier",
            logo: prettier,
          },
          {
            tech: "SonarQube",
            logo: sonarqube,
          },
          {
            tech: "Axios",
            logo: axios,
          },
          {
            tech: "Docker",
            logo: docker,
          },
          {
            tech: "GitHub",
            logo: gh,
          },
          {
            tech: "GitHub Runner",
            logo: gitrunner,
          },
          {
            tech: "EC2",
            logo: ec2,
          },
          {
            tech: "Fargate",
            logo: fargate,
          },
          {
            tech: "ECR",
            logo: ecr,
          },
          {
            tech: "ECS",
            logo: ecs,
          },
          {
            tech: "IAM",
            logo: iam,
          },
          {
            tech: "Cloud Watch",
            logo: cw,
          },
          {
            tech: "Cloud Formation",
            logo: cloudformation,
          },
          {
            tech: "WAF",
            logo: waf,
          },
          {
            tech: "ALB",
            logo: alb,
          },
          {
            tech: "Gen AI",
            logo: genai,
          },
        ],
      },
      {
        title: "Extra works",
        des: "I proactively share my knowledge and expertise by conducting knowledge transfer (KT) sessions on the platform for team members, React JS concepts, good coding practices, maintaing code quality, enhanced the perfomence and more. I also help commerces get up to speed by reviewing their code and providing feedback. Additionally, I collaborate with cross-functional teams to improve the performance and quality of the platform.",
        techs: [],
      },
    ],
  },
  {
    title: "Software Engineer (Frontend Specialist)",
    where: "Innodata Lanka (Pvt) Ltd",
    startDate: "2022-06-01",
    endDate: "2024-12-31",
    logo: inno,
    des: "Innodata is a global data engineering company delivering the promise of AI to many of the world's most prestigious companies. In here I'm working with Intelligent Automated Publishing Platform.",
    items: [
      {
        title: "Intelligent Automated Publishing Platform",
        des: "Intelligent Automated Publishing Platform is a platform that automates the publishing process of content. I was the one who integrated React JS frontend with this project, developed the UI for main features, checked and enhanced the system performance, and developed features to support cross-browser compatibility.",
        techs: [
          {
            tech: "React JS",
            logo: react,
          },
          {
            tech: "Bootstrap",
            logo: bootstrap,
          },
          {
            tech: "React Bootstrap",
            logo: reactbootstrap,
          },
          {
            tech: "jQuery",
            logo: jquery,
          },
          {
            tech: "JavaScript",
            logo: js,
          },
          {
            tech: "HTML",
            logo: html,
          },
          {
            tech: "CSS",
            logo: css,
          },
          {
            tech: "Sass",
            logo: sass,
          },
          {
            tech: "PHP",
            logo: php,
          },
          {
            tech: "Laravel",
            logo: laravel,
          },
          {
            tech: "Axios",
            logo: axios,
          },
          {
            tech: "MySQL",
            logo: mysql,
          },
          {
            tech: "GitLab",
            logo: gl,
          },
          {
            tech: "Jira",
            logo: jira,
          },
        ],
      },
      {
        title: "Extra works",
        des: "I proactively share my knowledge and expertise by conducting knowledge transfer (KT) sessions on the platform for team members, React JS concepts, good coding practices, maintaing code quality, enhanced the perfomence and more. I also help commerces get up to speed by reviewing their code and providing feedback. Additionally, I collaborate with cross-functional teams to improve the performance and quality of the platform.",
        techs: [],
      },
    ],
  },
  {
    title: "Software Developer (Fullstack)",
    where: "Nichelabs (Pvt) Ltd",
    startDate: "2021-09-01",
    endDate: "2022-06-30",
    logo: niche,
    des: "Nichelabs (Pvt) Ltd is a Sri Lankan based tech startup focused on the niche digital market of Europe. I worked as a Software Developer (Fullstack) for 9 months, where I developed, tested, and deployed high-quality software applications using a variety of programming languages and frameworks. I also worked with a team of engineers to design and implement new features for a variety of projects. Here are some of projects that I attend.",
    items: [
      {
        title: "CoinWolfs",
        des: "This website was created as a marketplace for crypto currencies. In here my cntibution were 100% for the UI/UX design part, Development part and hosting part.",
        techs: [
          {
            tech: "React JS",
            logo: react,
          },
          {
            tech: "Node JS",
            logo: node,
          },
          {
            tech: "Express JS",
            logo: express,
          },
          {
            tech: "GraphQL",
            logo: graphql,
          },
          {
            tech: "Apollo Client",
            logo: apollo,
          },
          {
            tech: "MongoDB",
            logo: mongodb,
          },
          {
            tech: "Axios",
            logo: axios,
          },
          {
            tech: "React Bootstrap",
            logo: reactbootstrap,
          },
          {
            tech: "Sass",
            logo: sass,
          },
          {
            tech: "S3",
            logo: s3,
          },
          {
            tech: "EC2",
            logo: ec2,
          },
          {
            tech: "ACM",
            logo: acm,
          },
          {
            tech: "IAM",
            logo: iam,
          },
          {
            tech: "R53",
            logo: r53,
          },
          {
            tech: "CloudFront",
            logo: cf,
          },
          {
            tech: "SES",
            logo: ses,
          },
          {
            tech: "GitHub",
            logo: gh,
          },
          {
            tech: "Asana",
            logo: asana,
          },
          {
            tech: "Figma",
            logo: figma,
          },
        ],
      },
      {
        title: "ITMe",
        des: "This platform was created for a tech base recruiter company. In here my cntibution were about 50% for the UI/UX design part, Development part and hosting part.",
        techs: [
          {
            tech: "React JS",
            logo: react,
          },
          {
            tech: "Node JS",
            logo: node,
          },
          {
            tech: "Express JS",
            logo: express,
          },
          {
            tech: "GraphQL",
            logo: graphql,
          },
          {
            tech: "Apollo Client",
            logo: apollo,
          },
          {
            tech: "MongoDB",
            logo: mongodb,
          },
          {
            tech: "Axios",
            logo: axios,
          },
          {
            tech: "React Bootstrap",
            logo: reactbootstrap,
          },
          {
            tech: "Sass",
            logo: sass,
          },
          {
            tech: "S3",
            logo: s3,
          },
          {
            tech: "EC2",
            logo: ec2,
          },
          {
            tech: "ACM",
            logo: acm,
          },
          {
            tech: "IAM",
            logo: iam,
          },
          {
            tech: "R53",
            logo: r53,
          },
          {
            tech: "CloudFront",
            logo: cf,
          },
          {
            tech: "GitHub",
            logo: gh,
          },
          {
            tech: "Asana",
            logo: asana,
          },
          {
            tech: "Figma",
            logo: figma,
          },
        ],
      },
      {
        title: "CAREKLEEN",
        des: "This is a mobile app with web dashbord application created for an Enterprise level janitorial service situated in Sri Lanka which employs over 3,500 employees to provide services to the largest corporations in Sri Lanka. In here my cntibution were about 25% for the dashboard development.",
        techs: [
          {
            tech: "Vue JS",
            logo: vue,
          },
          {
            tech: "Node JS",
            logo: node,
          },
          {
            tech: "Express JS",
            logo: express,
          },
          {
            tech: "GraphQL",
            logo: graphql,
          },
          {
            tech: "Apollo Client",
            logo: apollo,
          },
          {
            tech: "MongoDB",
            logo: mongodb,
          },
          {
            tech: "Bootstrap",
            logo: bootstrap,
          },
          {
            tech: "GitHub",
            logo: gh,
          },
          {
            tech: "Asana",
            logo: asana,
          },
        ],
      },
    ],
  },
  {
    title: "Software Engineer (Intern)",
    where: "99x",
    startDate: "2021-01-01",
    endDate: "2021-07-01",
    logo: logo99x,
    des: "99x is one of Asia’s best workplaces and a global leader in agile product engineering and technology innovation. Headquartered in Norway with offices in Oslo and Colombo, Sri Lanka. I worked as a Software Engineer (Intern) for 6 months, with the team 'Bonfire' and currently, it rebranded as the 'Superglu'.",
    items: [
      {
        title: "Superglu",
        des: "Superglu is an employee engagement web & mobile application. In here I mostly engaged with the frontend web development & backend data handling. Main responsibility was to build new components, testing & bug fixing. 'Jira' platform was used as support to following the scrum process. Furthermore, gained some experience with creating UIs using Adobe XD & creating flyers & animations for project proposes as well.",
        techs: [
          {
            tech: "React JS",
            logo: react,
          },
          {
            tech: "Redux",
            logo: redux,
          },
          {
            tech: "Node JS",
            logo: node,
          },
          {
            tech: "Express JS",
            logo: express,
          },
          {
            tech: "Axios",
            logo: axios,
          },
          {
            tech: "Ant Design",
            logo: antd,
          },
          {
            tech: "Sass",
            logo: sass,
          },
          {
            tech: "DynamoDB",
            logo: dynamoDB,
          },
          {
            tech: "S3",
            logo: s3,
          },
          {
            tech: "EC2",
            logo: ec2,
          },
          {
            tech: "ACM",
            logo: acm,
          },
          {
            tech: "IAM",
            logo: iam,
          },
          {
            tech: "Lambda",
            logo: lamda,
          },
          {
            tech: "API Gateway",
            logo: api,
          },
          {
            tech: "CloudWatch",
            logo: cw,
          },
          {
            tech: "GitHub",
            logo: gh,
          },
          {
            tech: "Jira",
            logo: jira,
          },
        ],
      },
      {
        title: "Extra works",
        des: "Apart from that project works, Involved with internal teams called 'Innovatives' such as Tea&Tech, MobileFocused, DevOps, UniRelations, Quiz innovatives. From there, could able to organized industrial webinars, participated in the industrial quizes & involved with the editor team of the Mobile focused group monthly magazine.",
        techs: [],
      },
    ],
  },
  {
    title: "Nestern (Digital Asset Generator)",
    where: "Nestlé Lanka",
    startDate: "2021-07-01",
    endDate: "2021-11-01",
    logo: nestle,
    des: "Nestle Health Science is a leading comprehensive nutrition solutions provider in Sri Lanka. Due to the prevailing situation and market competition, I'm supported for find ethical interactive tools to reach new customers and make aware existing customers.",
    items: [
      {
        title: "Digital Asset Generator",
        des: "In here my main responsible was Develop an animated promotional video and graphics, and observations on new concepts and digital promotional trends.",
        techs: [
          {
            tech: "Adobe After Effects",
            logo: ae,
          },
          {
            tech: "Adobe Premiere Pro",
            logo: pr,
          },
          {
            tech: "Adobe Photoshop",
            logo: ps,
          },
          {
            tech: "Filmora",
            logo: filmora,
          },
        ],
      },
      {
        title: "Extra works",
        des: "Apart from that main objective, Involved with organizing committee of the 'Central Perk' which was the first virtual hangout of the Nestern batch 2021 and, organizing committee of the 'Global Nesternship Sportsfest Teambuilding - Team Maggie'",
        techs: [],
      },
    ],
  },
  {
    title: "UI & Graphic Designer",
    where: "Ashi Design",
    startDate: "2016-08-01",
    endDate: "Present",
    logo: ashi,
    des: "Ashi Design is a my own graphic design and UI design business that creates visually stunning and user-friendly designs for businesses of all sizes and anyone need suport from designing kind of things.",
    items: [
      {
        title: "UI Designing",
        des: "I specialize in creating visually appealing and user-friendly interfaces for a variety of platforms, including websites, mobile apps, and software. I am passionate about creating designs that are both aesthetically pleasing and functional. I believe that good UI design should be intuitive and easy to use, while also being visually engaging. I am always looking for new ways to improve the user experience, and I am always up-to-date on the latest design trends.",
        techs: [
          {
            tech: "Figma",
            logo: figma,
          },
          {
            tech: "Adobe XD",
            logo: xd,
          },
          {
            tech: "Adobe Photoshop",
            logo: ps,
          },
          {
            tech: "Adobe Illustrator",
            logo: il,
          },
          {
            tech: "HTML",
            logo: html,
          },
          {
            tech: "CSS",
            logo: css,
          },
          {
            tech: "Canva",
            logo: canva,
          },
        ],
      },
      {
        title: "Graphic Designing",
        des: " I specialize in creating visually appealing and effective graphics for a variety of purposes, including logos, branding, website design, social media graphics, and print materials. I am passionate about creating designs that are both aesthetically pleasing and functional. I believe that good graphic design should communicate a message clearly and effectively, while also being visually engaging. I am always looking for new ways to improve my designs, and I am always up-to-date on the latest design trends.",
        techs: [
          {
            tech: "Adobe Photoshop",
            logo: ps,
          },
          {
            tech: "Canva",
            logo: canva,
          },
          {
            tech: "Adobe Illustrator",
            logo: il,
          },
          {
            tech: "Adobe After Effects",
            logo: ae,
          },
          {
            tech: "Adobe Premiere Pro",
            logo: pr,
          },
          {
            tech: "Filmora",
            logo: filmora,
          },
          {
            tech: "Blender",
            logo: blender,
          },
        ],
      },
    ],
  },
  {
    title: "Pencil Portrait Artist",
    where: "A & C ArtHub",
    startDate: "2016-01-01",
    endDate: "Present",
    logo: ac,
    des: "A & C ArtHub is a my own business that provides high-quality pencil portrait drawing services. I specialize in creating realistic and expressive portraits of people, animals, landscapes, and more. I am skilled in a variety of drawing techniques, including shading, blending, and stippling.",
    items: [],
  },
];

export const qualifications = [
  {
    title: "B.Sc. Information & Communication Technology",
    where: "University of Sri Jayewardenepura - Sri Lanka",
    startDate: "2017-11-13",
    endDate: "2021-12-21",
    logo: sjp,
    des: "The B.Sc. Information & Communication Technology degree program at the University of Sri Jayewardenepura, offered by the Department of Computer Science in the Faculty of Applied Sciences, is a highly competitive and prestigious program. With a limited intake of only 50 students from across the country in one academic year, the program provides a focused and personalized learning experience. It includes subjects such as mathematics and physics, equipping students with a strong foundation in ICT and technology. The university is renowned for its academic excellence and research contributions, providing a conducive learning environment and state-of-the-art facilities, preparing students for successful careers in the dynamic field of Information & Communication Technology. some of main subjects included in this degree program are listed down below.",
    items: [
      "Fundamentals of Computer Programming",
      "Computer Programming",
      "Software Engineering",
      "Computer Architecture",
      "Software Architecture & Design",
      "Data Stuctures & Algorithms",
      "Object Oriented Programming",
      "Database Systems and Administration",
      "User Interface Design & Implementation",
      "Visual Computing",
      "Multimedia Technologies",
      "Human Computer Interaction",
      "Introduction to Artificail Intelligence",
      "Computer Network & System Administration",
      "Operating Systems",
      "Embedded Systems",
      "Software Quality Assurance",
      "Data Mining & Data Warehousing",
    ],
  },
  {
    title: "Best Creative Designer Award (Semifinalist)",
    where: "JESA Awards Ceremony CSDS - USJ",
    startDate: "2021-05-01",
    endDate: "",
    logo: jesa21,
    certificateLink: "",
    des: "JESA (J'pura Employability Skills Awards) is a grand event which is organized by the Career Skills Development Society of the University of Sri Jayewardenepura with the aspiration of rewarding the brilliant undergraduates who have been proficient at balancing their academics and the extracurricular activities they are engaged in and have shown commendable results in both of these fields, surpassing the expectations. Also, JESA will be the greatest inspiration for all the undergraduates to pursue the skills and to be equipped with the competencies they need in both their personal and professional pursuits.",
    items: [
      "This award was specially introduced to upscale the skills of undergraduates with skills and abilities in fields such as Graphic Designing, Photography, and Art. The undergraduates are motivated to develop their extracurricular and co-curricular skills through competing for this award.",
      "It's a great pleasure for being selected for the semifinals of the Best Creative Designer award as being an undergraduate",
    ],
  },
  {
    title: "AWS S3 Basics",
    where: "Coursera Project Network",
    startDate: "2020-06-19",
    endDate: "",
    logo: cpn,
    certificateLink:
      "https://coursera.org/share/3a30ddd8e4ebe9d818129b0736c6d030",
    des: "Following points are coverd by this certificate course.",
    items: [
      "Create your First S3 Bucket and Upload Content to Bucket and Manage their Access",
      "Create Static Website using AWS S3",
      "Enable S3 Encryption, S3 Versioning and Lifecycle management rules on S3 Bucket",
    ],
  },
  {
    title: "Introduction to Conversational Interfaces",
    where:
      "FutureLearn | UAL Creative Computing Institute | Institute of Coding",
    startDate: "2020-08-18",
    endDate: "",
    logo: fl,
    certificateLink: "https://www.futurelearn.com/certificates/rbq2vnh",
    des: "Following points are coverd by this certificate course.",
    items: [
      "Describe what conversational interfaces are and how the technology works at a basic level.",
      "Summarise the main developments and history of conversational interfaces.",
      "Compare different types of conversational interfaces and identify good use cases for the technology.",
      "Explain the benefits of using a conversational interface.",
      "Identify the skills required to create a good conversational interface.",
      "Discuss the ethical considerations around designing conversational interfaces.",
    ],
  },
  {
    title: "Technical Support Fundamentals",
    where: "Coursera | Google",
    startDate: "2020-08-18",
    endDate: "",
    logo: cl,
    certificateLink:
      "https://coursera.org/share/1964308c79c20321b6cc1950b7070c86",
    des: "Following points are coverd by this certificate course.",
    items: ["Binary Code", "Customer Support", "Linux", "Troubleshooting"],
  },
  {
    title: "AI Chatbots without programming (CB0103EN)",
    where: "edX | IBM",
    startDate: "2020-08-19",
    endDate: "",
    logo: edX,
    certificateLink:
      "https://courses.edx.org/certificates/ec808e37f2824a3aa793f8a5cfa07451",
    des: "Following points are coverd by this certificate course.",
    items: [
      "What chatbots are and why they are revolutionary",
      "What WatsonAssistant is and how you can leverage its AI capabilities",
      "The key principles of good chatbot design",
      "How to create your own chatbot withoutthe need to write any code",
      "How to deploy your chatbot on WordPress sites",
      "How to enroll as an IBM Partner if you intend to build chatbots for customers",
      "How to makemoney with chatbots",
    ],
  },
  {
    title: "Introduction to Artificial Intelligence (AI)",
    where: "Coursera | IBM",
    startDate: "2020-08-19",
    endDate: "",
    logo: cl,
    certificateLink:
      "https://coursera.org/share/722df4667e666173fb879766192beecb",
    des: "Following points are coverd by this certificate course.",
    items: [
      "Describe what is AI, its applications, use cases, and how it is transforming our lives",
      "Describe several issues and ethical concerns surrounding AI",
      "Explain terms like Machine Learning, Deep Learning and Neural Networks",
      "Articulate advice from experts about learning and starting a career in AI",
    ],
  },
  {
    title: "Introduction to Creative AI",
    where:
      "FutureLearn | UAL Creative Computing Institute | Institute of Coding",
    startDate: "2020-08-18",
    endDate: "",
    logo: fl,
    certificateLink: "https://www.futurelearn.com/certificates/rbq2vnh",
    des: "Following points are coverd by this certificate course.",
    items: [
      "Describe how the creative industries are using AI and machine learning at a basic level.",
      "Compare different types of machine learning and AI approaches that are used in the creative industries.",
      "Debate the potential of AI to create new media.",
      "Summarise deep learning and its application to creative industries.",
      "Explain how AI systems are developed.",
      "Identify the skills required to work in creative AI.",
    ],
  },
  {
    title: "The Bits and Bytes of Computer Networking",
    where: "Coursera | Google",
    startDate: "2020-08-18",
    endDate: "",
    logo: cl,
    certificateLink:
      "https://coursera.org/share/1964308c79c20321b6cc1950b7070c86",
    des: "Following points are coverd by this certificate course.",
    items: [
      "Domain Name System (DNS)",
      "Ipv4 & Ipv6",
      "Network Model",
      "Troubleshooting",
    ],
  },
  {
    title: "Creating a Calculator App with Flutter",
    where: "Coursera Project Network",
    startDate: "2021-05-15",
    endDate: "",
    logo: cpn,
    certificateLink:
      "https://coursera.org/share/33a4b40e932d20fcbb182a9506c18875",
    des: "",
    items: [],
  },
  {
    title: "Creating an Interactive Story with Flutter",
    where: "Coursera Project Network",
    startDate: "2021-05-15",
    endDate: "",
    logo: cpn,
    certificateLink:
      "https://coursera.org/share/224d564b615f53d06766cc1bd15a48bf",
    des: "",
    items: [],
  },
];

export const teamWorks = [
  {
    title: "Cheif Organizer - TTP Job fair (FHSS & FAHS Episode)",
    where: "Career Skills Development Society - USJ",
    startDate: "2018-12-15",
    endDate: "2019-02-28",
    logo: ttp,
    des: "Touch the Peak job fair is the largest platform for Career Exploration and Development for all students and recent graduates of University of Sri Jayewardenepura. The fair is organized by the Career Skills Development Society (CSDS) of USJ, and CSDS is conducting multiple episodes for each & every faculties annualy. This episode was specialy open to all students and recent graduates of the Faculty of Humanities and Social Sciences (FHSS) and Faculty of Allied Health Sciences (FAHS).",
    items: [
      "The fair featured over 100 participating companies from the private and public sectors, including banks, government agencies, NGOs, and multinational corporations. Students had the opportunity to meet with representatives from these companies, learn about their hiring needs, and apply for jobs.",
      "The event also featured a series of workshops on topics such as resume writing, interview skills, and career planning. These workshops were designed to help students develop the skills they need to succeed in the job market.",
      "Over 1,000 students attended this event, and over 400 job applications were submitted. The fair was also well-received by the participating companies, who praised the quality of the students and the organization of the event.",
    ],
  },
  {
    title: "Advisory Board Member - CSDS",
    where: "Career Skills Development Society - USJ",
    startDate: "2020-01-15",
    endDate: "2020-12-31",
    logo: csds,
    des: "The Advisory Board of the Career Skills Development Society (CSDS) is a group of experienced professionals who provide guidance and support to the society on its strategic direction. A unique feature of the Advisory Board is that it is created from the selected few top members of the past executive board. This ensures that the board has a deep understanding of the society's history and culture, and that it is able to provide valuable insights and advice to the current executive board.",
    items: [
      "Provide guidance and support to the society's leadership.",
      "Help to shape the society's strategic direction.",
      "Provide advice on specific areas of expertise.",
    ],
  },
  {
    title: "IT Bureau - CSDS",
    where: "Career Skills Development Society - USJ",
    startDate: "2018-12-01",
    endDate: "2019-12-19",
    logo: csds,
    des: "The IT Bureau is a important position of the executive board of the Career Skills Development Society (CSDS) of the University of Sri Jayewardenepura (USJ).  IT Bureau is responsible for the overall IT infrastructure and operations of the society. The IT Bureau is the main position next to the Vice President (IT)",
    items: [
      "Manage the society's technical stuffs.",
      "Maintain the all CSDS social media platforms",
      "Manage the sub IT groups of the society.",
      "Provide IT support to members.",
    ],
  },
  {
    title: "Organizing Committee Member - JESA",
    where: "Career Skills Development Society - USJ",
    startDate: "2019-04-21",
    endDate: "2019-08-31",
    logo: jesa19,
    des: "JESA (J'pura Employability Skills Awards) is a grand event which is organized by the Career Skills Development Society of the University of Sri Jayewardenepura with the aspiration of rewarding the brilliant undergraduates who have been proficient at balancing their academics and the extracurricular activities they are engaged in and have shown commendable results in both of these fields, surpassing the expectations. Also, JESA will be the greatest inspiration for all the undergraduates to pursue the skills and to be equipped with the competencies they need in both their personal and professional pursuits.",
    items: [
      "Planning the logistics of the awards ceremony, such as the venue, the catering, and the entertainment.",
      "Secures sponsors to help fund the awards ceremony.",
      "Managing the budget for the awards ceremony.",
      "Communicating with stakeholders, such as the sponsors, the volunteers, and the participants.",
    ],
  },
  {
    title: "Committee Member - CSS",
    where: "Computer Science Society - USJ",
    startDate: "2019-02-10",
    endDate: "2020-02-10",
    logo: cssl,
    des: "The Computer Science Society (CSS) is a student-run organization at the University of Sri Jayewardenepura (USJ) that aims to promote the study of computer science and to provide opportunities for students to network with each other and with professionals in the field. The Committee Members of the executive board are responsible for planning and executing the society's activities, such as workshops, seminars, and hackathons.",
    items: [
      "Helping to plan and execute the society's activities.",
      "Communicating with the stakeholders, such as the faculty, the students, and the sponsors.",
      "Recruiting members to join the society.",
    ],
  },
  {
    title: "Competition Committee Head - Aurora - CSS",
    where: "Computer Science Society - USJ",
    startDate: "2018-08-01",
    endDate: "2018-10-30",
    logo: cssl,
    des: "Aurora - conference on Computer Science is the first conference & hackathon for the school children organized by the Computer Science Society (CSS) of the University of Sri Jayewardenepura (USJ). The event is opened to all students, and it provides participants with the opportunity to showcase their skills in software, hardware, and Artificial Intelligence. The Competition Committee was responsible for organizing and managing the all hackathon & game events of Aurora.",
    items: [
      "Planning the events such as the coding challenges, the design challenges, and the puzzle chalanges.",
      "Recruiting judges to evaluate the participants' submissions.",
      "Managing the logistics of the events, such as the venue, the catering, and the prizes.",
      "Communicating with stakeholders, such as the participants, the sponsors, and the judges.",
    ],
  },
  {
    title: "Organizing Committee Member - Lab 3's Project",
    where: "Leo Club of District 306 C2 - USJ",
    startDate: "2020-06-01",
    endDate: "2020-12-31",
    logo: leo,
    des: "Lab 3's Project is an awareness program organized by the Leo Club of District 306 C2 - USJ to raise awareness of chemical management and chemical safety. The project aims to educate students, teachers, and the general public about the importance of safe handling of chemicals. The project will also provide information about the different types of chemicals and their hazards.",
    items: [
      "Planning & organized webinar sessions with experts of the industry.",
      "Organized socail media campaign with posting flyers, and posters.",
      "Designing the flyers, and posters.",
    ],
  },
  {
    title: "Secretary - IEEEXtreame Hackathon",
    where: "IEEE Student Branch of USJ",
    startDate: "2019-11-01",
    endDate: "2019-12-14",
    logo: ieee,
    des: "IEEEXtreme is a global challenge in which teams of IEEE student members from universities around the world compete to solve a set of programming problems. The competition is held annually and is open to all IEEE student members. ",
    items: [
      "15+ teams participated in that event, which was held at the engineering faculty premises of University of Sri Jayewardenepura.",
    ],
  },
];

export const techSkills = [
  {
    title: "Languages",
    techs: [
      {
        tech: "JavaScript",
        logo: js,
      },
      {
        tech: "TypeScript",
        logo: ts,
      },
      {
        tech: "HTML",
        logo: html,
      },
      {
        tech: "CSS",
        logo: css,
      },
      {
        tech: "Sass",
        logo: sass,
      },
      {
        tech: "PHP",
        logo: php,
      },
      {
        tech: "Dart",
        logo: dart,
      },
      {
        tech: "Python",
        logo: python,
      },
      {
        tech: "Pascal",
        logo: pascal,
      },
      {
        tech: "Java",
        logo: java,
      },
      {
        tech: "C",
        logo: c,
      },
    ],
  },
  {
    title: "Frameworks & Libraries",
    techs: [
      {
        tech: "React JS",
        logo: react,
      },
      {
        tech: "Next JS",
        logo: next,
      },
      {
        tech: "Redux",
        logo: redux,
      },
      {
        tech: "jQuery",
        logo: jquery,
      },
      {
        tech: "Vue JS",
        logo: vue,
      },
      {
        tech: "Vite",
        logo: vite,
      },
      {
        tech: "Flutter",
        logo: flutter,
      },
      {
        tech: "Laravel",
        logo: laravel,
      },
      {
        tech: "Bootstrap",
        logo: bootstrap,
      },
      {
        tech: "React Bootstrap",
        logo: reactbootstrap,
      },
      {
        tech: "Material UI",
        logo: mui,
      },
      {
        tech: "Material Tailwind",
        logo: mt,
      },
      {
        tech: "Ant Design",
        logo: antd,
      },
    ],
  },
  {
    title: "BackEnd & API Development",
    techs: [
      {
        tech: "Node JS",
        logo: node,
      },
      {
        tech: "Express JS",
        logo: express,
      },
      {
        tech: "GraphQL",
        logo: graphql,
      },
      {
        tech: "REST API",
        logo: rest,
      },
      {
        tech: "Apollo Client",
        logo: apollo,
      },
      {
        tech: "Axios",
        logo: axios,
      },
    ],
  },
  {
    title: "Database Management",
    techs: [
      {
        tech: "MongoDB",
        logo: mongodb,
      },
      {
        tech: "MySQL",
        logo: mysql,
      },
      {
        tech: "DynamoDB",
        logo: dynamoDB,
      },
    ],
  },
  {
    title: "DevOps s& Infrastructure",
    techs: [
      {
        tech: "S3",
        logo: s3,
      },
      {
        tech: "EC2",
        logo: ec2,
      },
      {
        tech: "ACM",
        logo: acm,
      },
      {
        tech: "IAM",
        logo: iam,
      },
      {
        tech: "R53",
        logo: r53,
      },
      {
        tech: "CloudFront",
        logo: cf,
      },
      {
        tech: "DynamoDB",
        logo: ddb,
      },
      {
        tech: "Lambda",
        logo: lamda,
      },
      {
        tech: "SES",
        logo: ses,
      },
      {
        tech: "API Gateway",
        logo: api,
      },
      {
        tech: "CloudWatch",
        logo: cw,
      },
      {
        tech: "CloudFormation",
        logo: cloudformation,
      },
      {
        tech: "ALB",
        logo: alb,
      },
      {
        tech: "ECR",
        logo: ecr,
      },
      {
        tech: "ECS",
        logo: ecs,
      },
      {
        tech: "Fargate",
        logo: fargate,
      },
      {
        tech: "WAF",
        logo: waf,
      },
      {
        tech: "GitHub Runner",
        logo: gitrunner,
      },
      {
        tech: "Docker",
        logo: docker,
      },
    ],
  },
  {
    title: "Web Hosting",
    techs: [
      {
        tech: "AWS",
        logo: aws,
      },
      {
        tech: "Vercel",
        logo: vercel,
      },
      {
        tech: "cPanel",
        logo: cp,
      },
    ],
  },
  {
    title: "Version Control & Project Management",
    techs: [
      {
        tech: "GitHub",
        logo: gh,
      },
      {
        tech: "GitLab",
        logo: gl,
      },
      {
        tech: "BitBucket",
        logo: bb,
      },
      {
        tech: "Jira",
        logo: jira,
      },
      {
        tech: "Asana",
        logo: asana,
      },
    ],
  },
  {
    title: "Code Smells",
    techs: [
      {
        tech: "ES Lint",
        logo: eslint,
      },
      {
        tech: "Prettier",
        logo: prettier,
      },
      {
        tech: "SonarQube",
        logo: sonarqube,
      },
    ],
  },
  {
    title: "Design and Multimedia",
    techs: [
      {
        tech: "Figma",
        logo: figma,
      },
      {
        tech: "Adobe XD",
        logo: xd,
      },
      {
        tech: "Canva",
        logo: canva,
      },
      {
        tech: "Adobe Photoshop",
        logo: ps,
      },
      {
        tech: "Adobe Illustrator",
        logo: il,
      },
      {
        tech: "Adobe After Effects",
        logo: ae,
      },
      {
        tech: "Adobe Premiere Pro",
        logo: pr,
      },
      {
        tech: "Filmora",
        logo: filmora,
      },
      {
        tech: "Blender",
        logo: blender,
      },
    ],
  },
];

export const myData = {
  aboutDes:
    "I am skilled in related web technologies as a developer with experience in web application development. And also, I am a skilled UI/UX designer and have experience creating visually appealing and user-friendly interfaces. My capacity to resolve challenging issues is one of my finest assets. No matter how difficult the assignment is, I am tenacious and never give up, always finding a solution. This, together with my short learning curve for new technology, has enabled me to continuously provide results that exceed expectations.",
  profExp: {
    header: "Professional Experiences",
    data: profExperiences,
  },
  qualifi: {
    header: "Qaulifications",
    data: qualifications,
  },
  techSkills: {
    header: "Tech Skills",
    data: techSkills,
  },
  softSkills: {
    header: "Team Work & Leadership",
    data: teamWorks,
  },
  contacts: {
    email: "adeeshaashinshana@gmail.com",
    mobile: "+9476 4149 608",
    whatsapp: "+9475 6192 801",
    address1: "194/A, Parakatawella",
    address2: "Pilimatalawa",
    address3: "Kandy",
    address4: "Sri Lanka",
  },
  socialLinks: {
    linkedin: "https://linkedin.com/in/adeesha-ashinshana-mahalekam-233134139",
    email: "adeeshaashinshana@gmail.com",
    git: "https://github.com/adeeshaashinshana",
    medium: "https://medium.com/@adeeshaashinshana",
    fb: "https://web.facebook.com/adeesha.ashinshanamahalekam",
    insta: "https://www.instagram.com/adeesha_ashinshana",
    twiter: "https://twitter.com/AdeeshaMahalek1",
  },
};

export const eventImgs = [
  <img
    src={ev30}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Graduation 1"
  />,
  <img
    src={ev1}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSDS Glory Night 1"
  />,
  <img
    src={ev31}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Graduation 2"
  />,
  <img
    src={ev2}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam JESA Semifinalist - Best Creative Designer"
  />,
  <img
    src={ev3}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSDS Glory Night 2"
  />,
  <img
    src={ev4}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Graduation 3"
  />,
  <img
    src={ev5}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Nesternship 1"
  />,
  <img
    src={ev6}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Nesternship 2"
  />,
  <img
    src={ev7}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Nesternship 3"
  />,
  <img
    src={ev8}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Nesternship 4"
  />,
  <img
    src={ev9}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam V-Real webinar"
  />,
  <img
    src={ev10}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam 99x vesak"
  />,
  <img
    src={ev11}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam 99x Bristol Quiz Competition"
  />,
  <img
    src={ev12}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSDS Glory Night 3"
  />,
  <img
    src={ev13}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSDS Glory Night 4"
  />,
  <img
    src={ev14}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSDS Glory Night 5"
  />,
  <img
    src={ev15}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSR Seminar 1"
  />,
  <img
    src={ev16}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSR Seminar 2"
  />,
  <img
    src={ev17}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSR Seminar 3"
  />,
  <img
    src={ev18}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam CSR Seminar 4"
  />,
  <img
    src={ev19}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam JESA Organizing comittee 1"
  />,
  <img
    src={ev20}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SJP FAS ICT Freshers Welcome 1"
  />,
  <img
    src={ev21}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SJP FAS ICT Freshers Welcome 2"
  />,
  <img
    src={ev22}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SJP FAS SCS Aurora 1"
  />,
  <img
    src={ev23}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SJP FAS SCS Aurora 2"
  />,
  <img
    src={ev24}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SJP FAS SCS Aurora 3"
  />,
  <img
    src={ev25}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam Nichelabs Portrait Drawing Gift"
  />,
  <img
    src={ev26}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SSCK Sceincia exhibhition 1"
  />,
  <img
    src={ev27}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SSCK Sceincia exhibhition 2"
  />,
  <img
    src={ev28}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SSCK Sceincia exhibhition 3"
  />,
  <img
    src={ev29}
    loading="lazy"
    className="aboutPageImg"
    alt="Adeesha Mahalekam SSCK Astronomy night"
  />,
];
